"use client";

import GradualBlur from "@/components/gradual_blur/GradualBlur";
import { useEffect, useState } from "react";

export default function BlurController() {
    const [gradualBlurAvailability, setGradualBlurAvailability] = useState(false);

    useEffect(() => {
        if (typeof navigator !== "undefined" && typeof window !== "undefined" && navigator.hardwareConcurrency) {
            const cores = navigator.hardwareConcurrency;
            setGradualBlurAvailability(cores > 2);
        } else {
            setGradualBlurAvailability(false);
        }
    }, []);

    if (!gradualBlurAvailability) return null;

    return (
        <GradualBlur
            target="page"
            position="bottom"
            animated="scroll"
            curve="bezier"
            exponential
            duration="1s"
            gpuOptimized
            preset="bottom"
            responsive
        />
    );
}
